import { FormattedMessage, useIntl } from 'react-intl';
import { Text } from '../../ui-components';
import { NotificationBanner } from '../notification-banner/NotificationBanner';

export interface BackorderBannerProps {
    productId: string;
    c_inStockDate: string;
    selectedQuantityInStock: number;
    selectedQuantityInBackorder: number;
    isOnlyBackOrder: boolean;
}

export const BackorderBanner = ({
    productId,
    c_inStockDate,
    isOnlyBackOrder,
    selectedQuantityInStock,
    selectedQuantityInBackorder,
}: BackorderBannerProps) => {
    const intl = useIntl();

    if (!c_inStockDate || !productId) {
        return null;
    }

    const formattedInstockDate = intl.formatDate(c_inStockDate, {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    });

    return (
        <NotificationBanner id={`backorder-banner-${productId}`}>
            <Text id={`product-detail-in-stock-date-${productId}-header`} style="bold">
                <FormattedMessage
                    id="quantity.message.backordered.on-backorder"
                    defaultMessage="On Backorder"
                />
            </Text>

            <Text id={`product-detail-in-stock-date-${productId}-body`}>
                {isOnlyBackOrder ? (
                    <FormattedMessage
                        id="product.on.backorder.message"
                        defaultMessage="The expected in-stock date is {inStockDate}. Backorder items will ship separately."
                        values={{
                            inStockDate: formattedInstockDate,
                        }}
                    />
                ) : (
                    <FormattedMessage
                        id="quantity.message.backordered.instockdate-non-bold"
                        defaultMessage="{selectedQuantityInStock} item(s) in-stock, and {selectedQuantityInBackorder} item(s) on backorder. The expected in-stock date is {inStockDate}. Backorder items will ship separately."
                        values={{
                            inStockDate: formattedInstockDate,
                            selectedQuantityInStock,
                            selectedQuantityInBackorder,
                        }}
                    />
                )}
            </Text>
        </NotificationBanner>
    );
};
